import { getBootstrapData } from "@swa-ui/bootstrap";
import { window } from "@swa-ui/browser";
import { getEnvironmentTier } from "@swa-ui/dotcom";

const getLowerEnvironmentURL = (urls) => {
  const hangarInfo = getBootstrapData("hangar-info");
  const { hostname } = window?.location || {};
  const lowerEnvironment = hostname?.split(".")?.[1];
  const hangarId = hangarInfo?.find((hangar) =>
    hangar.environments.some((environment) => lowerEnvironment === environment)
  )?.hangarId;

  return urls[`OJT_WEBAPP_BASE_PATH_NON_PROD_${hangarId}`] ?? urls.OJT_WEBAPP_BASE_PATH_NON_PROD;
};

export const useOJTWebappUrl = () => {
  const urls = getBootstrapData("urls");

  return getEnvironmentTier() === "prod"
    ? urls.OJT_WEBAPP_BASE_PATH_PROD
    : getLowerEnvironmentURL(urls);
};
